
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gsB19", function(module, exports) {
module.exports = JSON.parse('{"jsm-project-summary-onboarding.closeButton":"Fechar","jsm-project-summary-onboarding.moreAboutFeature":"Mais sobre o resumo do espa\xe7o","jsm-project-summary-onboarding.okButton":"Entendi"}');

});


//# sourceMappingURL=pt-BR.c717b4e8.js.map
